<section class="section-intro">
  <div>
    <div fxLayout="row">
      <h3 *ngIf="sectionHeading">{{ sectionHeading }}</h3>
      <div *ngIf="showEditButton" fxLayout="row" class="edit-icon">
        <div class="icon-link" (click)="editButtonClick.emit()">
          <mat-icon>create</mat-icon>
        </div>
        <div class="icon-link" (click)="editButtonClick.emit()">
          <span><strong>Edit</strong></span>
        </div>
      </div>
    </div>
    <div>
      <ng-content></ng-content>
    </div>
  </div>
</section>
